import React from 'react';
import { GridColTypeDef, GridRenderCellParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";

import baseColumn from "./BaseColumn";
import { toPercentChangeString } from "components/widgets/charts/PercentChange/PercentChange";
import { Box, useTheme } from "@mui/material";

export default function percentChangeColumn() {
  const percentChangeColumn: GridColTypeDef = {
    ...baseColumn,
    type: "custom",
    align: "right",
    renderCell: (params: GridRenderCellParams) => {
      const { i18n } = useTranslation();
      const theme = useTheme();

      return (
        <Box
          sx={{
            color: params.value > 0 ?
              theme.colors.namedColors.positive :
              theme.colors.namedColors.negative
          }}>
          {toPercentChangeString(i18n, params.value)}
        </Box>
      );
    }
  };

  return percentChangeColumn;
}